import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import various from '../General/various';
import { AuthContext } from '../auth';

const LogOut = () => {
  const navigate = useNavigate();
  const { logout } = useContext(AuthContext);

  useEffect(() => {
    logout();
    alert('ログアウトしました');
    navigate(various.general.home);
  }, [logout, navigate]);

  return null;
};
export default LogOut;
